/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Busy_Known_Falcon_BloomInputs */

const fr_busy_known_falcon_bloom = /** @type {(inputs: Busy_Known_Falcon_BloomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment bien charger ta barre`)
};

/**

* @param {Busy_Known_Falcon_BloomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const busy_known_falcon_bloom = /** @type {((inputs?: Busy_Known_Falcon_BloomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Busy_Known_Falcon_BloomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_busy_known_falcon_bloom(inputs)
});